import {
  ActionType,
  AppRuleAction,
  AppRuleTrigger,
  TriggerType,
} from '@polybank/shared';
import { z } from 'zod';

export interface RulePresets {
  id?: string;
  title?: string;
  description?: string;
  triggers?: Partial<AppRuleTrigger>[];
  actions?: Partial<AppRuleAction>[];
}

export const createRuleFormSchema = (t: (key: string) => string) =>
  z.object({
    title: z.string().min(1, t('createRuleDialog.validation.titleRequired')),
    description: z.string(),
    triggers: z
      .array(
        z.object({
          $id: z.string().optional(),
          triggerType: z.nativeEnum(TriggerType),
          triggerValue: z
            .string()
            .min(1, t('createRuleDialog.validation.triggerValueRequired')),
        })
      )
      .min(1, t('createRuleDialog.validation.atLeastOneTrigger')),
    actions: z
      .array(
        z.object({
          $id: z.string().optional(),
          actionType: z.nativeEnum(ActionType),
          actionValue: z
            .string()
            .min(1, t('createRuleDialog.validation.actionValueRequired')),
        })
      )
      .min(1, t('createRuleDialog.validation.atLeastOneAction')),
  });

export type RuleFormValues = z.infer<ReturnType<typeof createRuleFormSchema>>;
